var angular = require('angular');
var _module = angular.module('benoit');
var config = require('config');
var hoiRates = require('./hoi-rates');

_module.factory('$mortgageCalculatorStore', [
    '$log',
    '$http',
    '$q',

    function $mortgageCalculatorStore($log, $http, $q) {
        // Class
        function MortgageCalculatorStore() {
            var _this = this;

            this.loading = true;
            this.interest_rates = {
                '30': undefined,
                '15': undefined,
                '51': undefined // 5-1 ARM
            };

            $q.all([
                this._fetchInterestRates()
            ])
            .finally(function () {
                _this.loading = false;
            });
        }

        // Private Functions
        MortgageCalculatorStore.prototype._fetchInterestRates = function _fetchInterestRates() {
            var _this = this;
            var promises = ['30-Yr FRM', '15-Yr FRM', '5/1-Yr ARM'].reduce(function (result, type) {
                var num = type.replace(/([^0-9])/gi, '');
                result[num] = $http.get(config.listreportsUrl + '/v1/mortgage-rates/' + encodeURIComponent(type));

                return result;
            }, {});

            return $q.all(promises)
            .then(function (response) {
                _this.interest_rates['30'] = response['30'].data.data;
                _this.interest_rates['15'] = response['15'].data.data;
                _this.interest_rates['51'] = response['51'].data.data;

                $log.debug('interest_rates', _this.interest_rates);
            })
            .catch(function onError(err) {
                $log.error('MortgageCalculatorStore -> _fetchInterestRates Error', err);
            });
        };

        // Public Functions
        /*
        Returns the Home Owners Insurance Rate based on the state

        @function getHOIRate
        @param {String} state - eg. ca
        */
        MortgageCalculatorStore.prototype.getHOIRate = function getHOIRate(state) {
            return hoiRates[state.toLowerCase()];
        };

        /*
        Calculates the monthly principal and interest payment

        @function calculatePrincipalAndInterestPayment
        @param {Number} principal - The amount for the loan
        @param {Number} interestRate - eg. 3.42
        @param {Number} numberOfPayments - The number of months you will be paying
        */
        MortgageCalculatorStore.prototype.calculatePrincipalAndInterestPayment = function calculateMonthlyPayment(principal, interestRate, numberOfPayments) {
            var interest = interestRate / 100 / 12;
            return principal * interest * (Math.pow(1 + interest, numberOfPayments)) / (Math.pow(1 + interest, numberOfPayments) - 1);
        };

        return new MortgageCalculatorStore();
    }
]);
